import { render, staticRenderFns } from "./matchingSetting.vue?vue&type=template&id=a9990270&scoped=true"
import script from "./matchingSetting.vue?vue&type=script&lang=js"
export * from "./matchingSetting.vue?vue&type=script&lang=js"
import style0 from "./matchingSetting.vue?vue&type=style&index=0&id=a9990270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9990270",
  null
  
)

export default component.exports